export default "__VITE_ASSET__Bo_1jE0f__"